import { AbstractDataProviderV2, ActionTypes } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular/A9Service';
import { RsCustomerExInfo } from 'common/customers/services/types/RsCustomerExInfo';
import { nationalGolfAssociation } from 'common/index/services/types';
import { CustomerExSync } from 'common/customers/services/types/CustomerExSync';
import { CustomerExUpdate } from 'common/customers/services/types/CustomerExUpdate';
import { CustomerExPatch } from 'common/customers/services/types/CustomerExPatch';

@A9Service('customerExternalIdDataProvider')
export class CustomerExternalIdDataProvider extends AbstractDataProviderV2<{}, RsCustomerExInfo, {}, CustomerExUpdate, CustomerExPatch> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/exs');
    }

    public list() {
        return Promise.reject('Method `list` is not available');
    }

    public add() {
        return Promise.reject('Method `add` is not available');
    }

    public remove() {
        return Promise.reject('Method `remove` is not available');
    }

    /**
     * Client should call PUT /rs/customers/{customerId}/exs/sync to define that some data was synchronized when it happens.
     * ticket #19624
     */
    public sync(customerId: number, system: nationalGolfAssociation): Promise<RsCustomerExInfo> {
        const url = this.helper.buildUrl(this.apiUrl + '/sync', { customerId: customerId });
        return this.service.updateRequest<RsCustomerExInfo>(url, 'PUT', <CustomerExSync>{ system: system }).then(result => {
            this.notify({ type: ActionTypes.Update, hash: url }, true);
            return result;
        });
    }
}
